import { render, staticRenderFns } from "./StacAsset.vue?vue&type=template&id=498ff85d"
import script from "./StacAsset.vue?vue&type=script&lang=js"
export * from "./StacAsset.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./StacAsset.vue?vue&type=style&index=0&id=498ff85d&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports